export default "__VITE_ASSET__tW5El$2l__"